import { Network } from '../../../../utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function searchPayments(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest({ searchText, page, limit, status }) {
  let url = `${urls.getAllPayments}?`
  if (searchText) url = `${urls.searchAllPayments}?query=${searchText}`
  else if(status) url=`${url}&status=${status}`
  url = `${url}&limit=${limit}&page=${page}`

  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  console.log(response)
  if (
    response &&
    response.status.code === 200 &&
    response.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalPayments(rawData)

    return {
      success: true,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseExternalPayments({data: []})

    return {
      success: true,
      data: appData,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { searchPayments }
